import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_INSURANCE_LOGIN } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import axios from "axios";
import { toast } from "../../components/app-toast";
import {
  getLocalizedMessage,
  getLocalizedErrorMessage,
} from "../../utils/messageHelper";
import i18n from "../../i18n";

export const postInsuranceLogin = createAsyncThunk(
  ACTION_INSURANCE_LOGIN.post_login,
  async (payload) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + APP_PATH.insuranceLogin,
        payload,
      );
      console.log("response:", response);
      // console.log('response:------------------------>',response?.data?.message);
      const message = getLocalizedMessage(response, i18n);
      toast.success(message);
      return response.data;
    } catch (error) {
      // console.log("error------------------>",error?.response?.data?.message);
      alert("sada");
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message || "error in Login");
      console.log("Error", error.data.message);
    }
  },
);
